import { Injectable } from '@angular/core';
import { HttpHelper } from 'nglhelper';
import { BehaviorSubject } from 'rxjs';
import * as jwt_decode from 'jwt-decode';

@Injectable()
export class AuthService {
    constructor(private http: HttpHelper) {
        const userStr = sessionStorage.getItem('User');

        if (userStr) {
            this.User = JSON.parse(userStr);
            http.SetBearerToken(this.User.Token);
        }
        /*
        var userStr = sessionStorage.getItem("User");

        if (userStr) {
            this._user = JSON.parse(userStr);
            this.jwt.Token = this._user.Token;
            if (this._user.SessionToken)
                this.jwt.SessionToken = this._user.SessionToken;

            this.User.next(this._user);
        }
        */
    }

    //_user;
    //User = new BehaviorSubject<any>(null);
    Title = new BehaviorSubject<any>(null);
    User;

    Login(user) {
        //do not store into local storage for activate account.
        this.http.SetBearerToken(user.Token);
        this.User = user;
        sessionStorage.setItem('User', JSON.stringify(this.User));

        /*
        this.jwt.Token = user.Token;
        if (user.SessionToken)
            this.jwt.SessionToken = user.SessionToken;
        this._user = user;
        if (!user.Action) {
            //console.log(JSON.stringify(user));
            sessionStorage.setItem("User", JSON.stringify(user));
        }
        this.User.next(this._user);
        */
    }

    SignOut() {
        //sessionStorage.removeItem("User");
        //this._user = null;
        //this.User.next(null);
        sessionStorage.removeItem('User');
        sessionStorage.removeItem('ContextUsername');
        this.User = null;
    }

    SetSite(obj) {
        /*
        this._user.SiteId = obj.SiteId;
        this._user.Token = obj.Token;
        this._user.AssetString = obj.AssetString;
        this._user.CompanyString = obj.CompanyString;
        this._user.AssetTypeMode = obj.AssetTypeMode;
        this._user.AllowBulkUpdate = obj.AllowBulkUpdate;

        this._user.AccessRights = obj.AccessRights;
        sessionStorage.setItem('User', JSON.stringify(this._user));

        this.jwt.Token = obj.Token;
        */
        this.User.SiteId = obj.SiteId;
        this.User.Token = obj.Token;
        this.User.AssetString = obj.AssetString;
        this.User.CompanyString = obj.CompanyString;
        this.User.AssetTypeMode = obj.AssetTypeMode;
        this.User.AllowBulkUpdate = obj.AllowBulkUpdate;
        this.User.AccessRights = obj.AccessRights;

        sessionStorage.setItem('User', JSON.stringify(this.User));
    }


    UpdateTitle(title, subtitle) {
        this.Title.next({
            Title: title,
            SubTitle: subtitle
        });
    }

    GetAccessRight(accessRight) {
        //return this._user.AccessRights[accessRight];
        if (!this.User)
            return 0;
        return this.User.AccessRights[accessRight] || 0;
    }

    IsSysadmin(){
        /*
        if(this._user.IsSysadmin)
            return this._user.IsSysadmin;
        else
            return false;
        */
       if(this.User.IsSysadmin)
            return this.User.IsSysadmin;
        else
            return false;
    }

    HasAccessRight(name, level = 1) {
        return this.GetAccessRight(name) >= level;
    }


    GetSiteId(){
        //return this._user.SiteId;
        return this.User.SiteId;
    }

    GetCompanyId(){
        //return this._user.CompanyId;
        return this.User.CompanyId;
    }

    GetAssetString(){
        //return this._user.AssetString || "Asset";
        return this.User.AssetString || "Asset";
    }

    GetCompanyString(){
        //return this._user.CompanyString || "Company";
        return this.User.CompanyString || "Company";
    }

    GetAssetTypeMode(){
        //return this._user.AssetTypeMode || "Multi";
        return this.User.AssetTypeMode || "Multi";
    }

    GetAllowBulkUpdate(){
        //return this._user.AllowBulkUpdate || false;
        return this.User.AllowBulkUpdate || false;
    }

    //JWT related
    getToken(): string {
        //return this.jwt.Token;
        let currData =  JSON.parse(sessionStorage.getItem('User'))
        if (!currData)
            return "";

        return currData.Token;
    }

    getTokenExpirationDate(token: string): Date {
        const decoded = jwt_decode(token);
    
        if (decoded.exp === undefined) return null;
    
        const date = new Date(0); 
        date.setUTCSeconds(decoded.exp);
        return date;
    }

    IsTokenExpired(token?: string): boolean {
        if(!token) token = this.getToken();
        if(!token) return true;
    
        const date = this.getTokenExpirationDate(token);
        if(date === undefined) return false;
        return !(date.valueOf() > new Date().valueOf());
    }

}